var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"stat-value",attrs:{"type":"number","step":"0.1","max":_vm.max,"placeholder":_vm.max},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.updateValue($event.target.value)}}})}
var staticRenderFns = []

export { render, staticRenderFns }